import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementStatisticsService {
  constructor(private api: ApiService) {}

  getPortalOverviewStatistics() {
    return this.api.getAPI('portal/management/statistics/overview').pipe(
      map((response: any) => {
        return response.body;
      })
    );
  }
}
